// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Summary_shadow__r-N0A","summary":"Summary_summary__1ZfC4","header":"Summary_header__2nlon","tabContainer":"Summary_tabContainer__QeQkL"};